import type { ColDef } from 'ag-grid-community';

// The app's custom filter components, registered by these names in each grid's `components`. They draw their own
// buttons. Filter handlers are on for every grid (`@/initializers/agGridLicense`), and on that path the grid also
// draws a button row whenever `filterParams.buttons` is set — so these filters get the list as `ownButtons`.
export const CUSTOM_FILTER_COMPONENTS: ReadonlyArray<string> = Object.freeze([
  'customSetColumnFilter',
  'customDateFilter',
  'bankFeedSetColumnFilter',
]);

const filterComponentName = (filter: ColDef['filter']): unknown =>
  filter && typeof filter === 'object' ? filter.component : filter;

export const isCustomFilterColumn = (column: Pick<ColDef, 'filter'>): boolean => {
  const name = filterComponentName(column.filter);
  return typeof name === 'string' && CUSTOM_FILTER_COMPONENTS.includes(name);
};
